import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BaseUrlContext from '../../contexts/BaseUrlContext';
import BidsPopupLoader from './BidsPopupLoader';
import useDetailHandler from '../../hooks/useDetailHandler';
import { auctionPropertiesType } from '../../types';
import './_styles_/ShowBidsPopupButton.css';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import PropTypes from 'prop-types';

ShowBidsPopupButton.propTypes = {
    auctionId: PropTypes.number.isRequired,
    auctionProps: auctionPropertiesType.isRequired,
};

function ShowBidsPopupButton(props) {
    const {
        auctionId,
        auctionProps,
    } = props;
    const { t } = useTranslation();
    const baseUrl = useContext(BaseUrlContext);
    const { isDetailVisible, toggleDetail } = useDetailHandler('bids');
    return (
        <div className="show-bids-popup-button--container">
            <NavLink to={`${baseUrl}/bids`} type="button" className="show-bids-popup-button" onClick={toggleDetail}>
                <FontAwesomeIcon icon="expand" />&nbsp;{t('auctions.button.show-bids-list')}
            </NavLink>
            {isDetailVisible && (
                <BidsPopupLoader
                    onCancelHandler={toggleDetail}
                    auctionId={auctionId}
                    auctionProps={auctionProps}
                />
            )}
        </div>
    );
}

export default withPrivileges([
    Privileges.BID_VIEW_OWN,
    Privileges.BID_VIEW_ALL,
    Privileges.BID_EDIT_OWN,
    Privileges.BID_EDIT_ALL,
    Privileges.BID_EDIT_AS_BROKER,
])(ShowBidsPopupButton);
